import React from "react";
import { Stack, Typography } from "@mui/material";
import Image from "next/image";
import { ColletteDivider } from "@collette-travel/collette-common-controls";
import { useTranslations, useFormatter } from "next-intl";
import { FeefoSummary } from "@/types/dto/destinations-page/destination-page-types";

interface FeefoSummaryGrayBarProps {
  feefoSummary?: FeefoSummary;
  testId?: string;
}

const FeefoSummaryGrayBar = ({ 
  feefoSummary, 
  testId = "feefo-summary-gray-bar" 
}: FeefoSummaryGrayBarProps) => {
  const t = useTranslations("HomePage");
  const formatter = useFormatter();
  
  if (!feefoSummary) return null;

  return (
    <Stack
      sx={{
        flexDirection: { xs: "column", lg: "row" },
        justifyContent: "center",
        alignItems: "center",
        gap: "1.2rem",
        height: "auto",
        my: "24px"
      }}
      data-testid={testId}
    >
      <Typography data-testid={`${testId}_description`}>
        {`${t("Rating out of 5", { rating: feefoSummary.stars })} ${t("Review count", {
          count:  Number.isInteger(feefoSummary.count) ? formatter.number(feefoSummary.count) : feefoSummary.count
        })}`}
      </Typography>

      <ColletteDivider
        flexItem
        testId={`${testId}_divider`}
        orientation="vertical"
        sx={{
          display: { xs: "none", lg: "block" },
          borderColor: "divider",
          borderWidth: "1px"
        }}
      />
      <Image
        src="https://i.gocollette.com/homepage/feefo_logo_grey.png"
        alt="feefo logo"
        height={20}
        width={88}
      />
    </Stack>
  );
};

export default FeefoSummaryGrayBar;
